import React from 'react';
import { Row, Col } from 'react-bootstrap';
import IconAmount from '../../../images/profile-icons/icon-amount.png';
import IconCalendar from '../../../images/profile-icons/icon-calendar.png';
import IconCard from '../../../images/profile-icons/icon-card.png';
import IconClock from '../../../images/profile-icons/icon-clock.png';
import IconPlan from '../../../images/profile-icons/icon-plane.png';
import IconPlanStatus from '../../../images/profile-icons/icon-plan-status.png';

interface SubscriptionInfo {
  planName: string;
  amount: string;
  status: string;
  startDate: string;
  endDate: string;
  terms: string;
  paymentMethod: string;
}

interface SubscriptionSectionProps {
  subscriptionInfo: SubscriptionInfo;
}

const SubscriptionSection: React.FC<SubscriptionSectionProps> = ({
  subscriptionInfo
}) => {
  return (
    <div className="subscription-section">
      <h5 className="fw-bold" style={{ color: "#3957A0" }}>
        Subscription Information
      </h5>
      <div className="subscription-details">
        <Row>
          <Col md={6}>
            <div className="detail-item">
              <img
                src={IconPlan}
                alt="Icon"
                className="detail-icon "
              />
              <span className="label mx-2">Plan Name:</span>
              <span className="value ">
                {subscriptionInfo.planName}
              </span>
            </div>

            <div className="detail-item">
              <img
                src={IconAmount}
                alt="Icon"
                className="detail-icon "
              />
              <span className="label mx-2">Amount:</span>
              <span className="value">
                {subscriptionInfo.amount}
              </span>
            </div>

            <div className="detail-item">
              <img
                src={IconClock}
                alt="Icon"
                className="detail-icon "
              />
              <span className="label mx-2">Terms:</span>
              <span className="value">
                {subscriptionInfo.terms}
              </span>
            </div>

            <div className="detail-item">
              <img
                src={IconCard}
                alt="Icon"
                className="detail-icon "
              />
              <span className="label mx-2">
                Payment Type:
              </span>
              <span className="value">
                {subscriptionInfo.paymentMethod}
              </span>
            </div>
          </Col>
          <Col md={6}>
            <div className="detail-item">
              <img
                src={IconCalendar}
                alt="Icon"
                className="detail-icon "
              />
              <span className="label mx-2">
                Start Date:
              </span>
              <span className="value">
                {subscriptionInfo.startDate}
              </span>
            </div>

            <div className="detail-item">
              <img
                src={IconCalendar}
                alt="Icon"
                className="detail-icon "
              />
              <span className="label mx-2">End Date:</span>
              <span className="value">
                {subscriptionInfo.endDate}
              </span>
            </div>

            <div className="detail-item">
              <img
                src={IconPlanStatus}
                alt="Icon"
                className="detail-icon "
              />
              <span className="label mx-2">Plan:</span>
              <span className="status-active">
                {subscriptionInfo.status}
              </span>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default SubscriptionSection;